export default "daaad69a90f9a286.svg"